module.exports = __webpack_public_path__ + "img/footer-logo.a8ed1af9.png";